import ef from 'ef/ef';
import SharedInitializationService from 'services/course-handler-services/initialization-service';

export default class InitializationService {
  static preload() {
    return ef.enrollment.fetch();
  }

  static load() {
    return [Promise.resolve()];
  }

  static applyTransformations(modulesJSON, modulesContentJson, groupsJSON) {
    return SharedInitializationService.applyTransformations(modulesJSON, modulesContentJson, groupsJSON);
  }
}
